import { render, staticRenderFns } from "./CaseAnalytics.vue?vue&type=template&id=8f3cb69e&scoped=true"
import script from "./CaseAnalytics.vue?vue&type=script&lang=js"
export * from "./CaseAnalytics.vue?vue&type=script&lang=js"
import style0 from "./CaseAnalytics.vue?vue&type=style&index=0&id=8f3cb69e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f3cb69e",
  null
  
)

export default component.exports